import { apiData, apiRequest } from "./http.js";
import { authorizeTikTokBasicProfile } from "@/services/tiktokAuth.js";
export async function getTikTokProfile(){ return apiData(await apiRequest("/api/auth/tiktok/profile")); }
export async function authorizeTikTokProfile(){ return apiData(await authorizeTikTokBasicProfile(apiRequest)); }
export async function logout(){ return apiData(await apiRequest("/api/auth/logout",{method:"POST",skipAuthBootstrap:true})); }
export function goToWechatEntry(){ window.location.assign("/entry"); }
